// @flow

function decodeFilterValue(value: string) {
    const regEx = /\+/g;
    return decodeURIComponent(value).replace(regEx, ' ');
}

function encodeFilterValue(value: string) {
    const regEx = /%20+/g;
    return encodeURIComponent(value).replace(regEx, '+');
}

const LOCATION_PARAM_KEY = 'Location Type';
const PROPERTY_PARAM_KEY = 'Property Type';
const FEATURE_PARAM_KEY = 'Features';

module.exports = {
    PROPERTY_PARAM_KEY,
    LOCATION_PARAM_KEY,
    FEATURE_PARAM_KEY,
    decodeFilterValue,
    encodeFilterValue
};
